import {
  ConfigService
} from '@/services/api'

import ItemTemplate from '@/components/Maps/InfoTextTemplates/Item'

function flattenObject(obj) {
  let toReturn = {}

  for (let i in obj) {
    if (!obj.hasOwnProperty(i)) continue

    if ((typeof obj[i]) === 'object' && obj[i] !== null) {
      let flatObject = flattenObject(obj[i])
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = obj[i]
    }
  }
  return toReturn
}

function unflattenObject(obj) {
  let result = {}
  for (let i in obj) {
    let keys = i.split('.')
    keys.reduce(function (r, e, j) {
      return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? obj[i] : {}) : [])
    }, result)
  }
  return result
}

function renameKeys(obj, fn) {
  if (typeof fn !== 'function') {
    return obj
  }

  const keys = Object.keys(obj)
  let result = {}

  for (var i = 0; i < keys.length; i++) {
    let key = keys[i]
    let val = obj[key]
    let str = fn(key, val)
    if (typeof str === 'string' && str !== '') {
      key = str
    }
    result[key] = val
  }
  return result
}

function setFilters(filters, currentFilters = {}) {
  filters.columns.forEach(column => {
    column.filters.forEach(filter => {
      if (filter.name) {
        currentFilters = {...currentFilters, [filter.name]: filter.value}
      } else {
        return setFilters(filter, currentFilters)
      }
    })
  })
  return currentFilters
}
function processMapProvider(provider) {
  provider = flattenObject(provider)
  for (let key in provider) {
    if (provider.hasOwnProperty(key)) {
      if (typeof provider[key] === 'string') {
        let matches = provider[key].match(/{{([^}]+)}}/g)
        if (Array.isArray(matches) && matches.length > 0) {
          for (let keyToReplace of matches) {
            provider[key] = provider[key].replace(keyToReplace, provider[keyToReplace.replace('{{', '').replace('}}', '')] || '')
          }
        }
      }
    }
  }
  return unflattenObject(provider)
}
function applyProductOverride(baseConfig, productConfig) {
  return {...baseConfig, ...productConfig}
}

export default {
  state: {
    toConfig: 0,
    configured: 0,
    configComplete: false,
    possibleProducts: [],
    ecosystem: {
      product: null,
      siteName: 'Moova',
      logo: '/static/img/moova.svg',
      logoLogin: '/static/img/moova-blue.svg',
      theme: 'moova',
      helpUrl: 'http://ayuda.moova.io/',
      googleRegister: true,
      terms: 'https://moova.io/terminos-y-condiciones/',
      privacy: 'https://moova.io/politica-de-privacidad/'
    },
    logo: '/static/img/moova.svg',
    logoPinned: null,
    ecosystemCountries: [],
    frontConfig: {},
    ecosystemConfig: {
      links: {
        help: '',
        terms: '',
        privacy: ''
      },
      googleRegister: false,
      extraCheckpoints: {
        beforePickup: false,
        beforeDelivery: false
      }
    },
    ecosystemModules: {
      couriers: {
        self: true
      },
      shippings: {
        self: true,
        shared: true
      },
      tours: {
        self: true,
        shared: true
      },
      items: {
        self: false,
        label: null,
        geolocalizableBy: null,
        templateInfoText: ItemTemplate.templateInfoText,
        icon: ItemTemplate.icon
      },
      geofences: false,
      companies: true,
      transactions: true,
      stores: {
        self: false,
        label: null
      }
    },
    ecosystemPlugins: null,
    ecosystemMaps: null,
    models: {},
    dataTransformers: {},
    quickFiltersSetup: {},
    plainQuickFiltersSetup: {},
    mapFiltersSetup: {},
    appRoles: [],
    vehicleTypes: [],
    shippingSizes: [],
    shippingTypes: [],
    shippingTypesShared: [],
    shippingSettings: [],
    platforms: [],
    receiverTypes: [],
    shippingStatusReasons: {},
    tobereturnedStatusReasons: [],
    geoTypes: [],
    spinner: false,
    vehicleTypeGroupVehicleTypes: [],
    commodityVarieties: []
  },
  getters: {
    toConfig: state => {
      return state.toConfig
    },
    configured: state => {
      return state.configured
    },
    configComplete: state => {
      return state.configComplete
    },
    possibleProducts: state => {
      return state.possibleProducts
    },
    ecosystem: state => {
      return state.ecosystem
    },
    logo: state => {
      return state.logo
    },
    logoPinned: state => {
      return state.logoPinned
    },
    ecosystemCountries: state => {
      return state.ecosystemCountries
    },
    frontConfig: state => {
      return state.frontConfig
    },
    ecosystemConfig: state => {
      return state.ecosystemConfig
    },
    ecosystemModules: state => {
      return state.ecosystemModules
    },
    ecosystemPlugins: state => {
      return state.ecosystemPlugins
    },
    ecosystemMaps: state => {
      return state.ecosystemMaps
    },
    models: state => {
      return state.models
    },
    dataTransformers: state => {
      return state.dataTransformers
    },
    quickFiltersSetup: state => {
      return state.quickFiltersSetup
    },
    plainQuickFiltersSetup: state => {
      return state.plainQuickFiltersSetup
    },
    mapFiltersSetup: state => {
      return state.mapFiltersSetup
    },
    appRoles: state => {
      return state.appRoles
    },
    vehicleTypes: state => {
      return state.vehicleTypes
    },
    vehicleTypesSelect: state => {
      return state.vehicleTypes.map((item) => {
        return {
          value: item.id,
          text: item.name
        }
      })
    },
    shippingSizes: state => {
      return state.shippingSizes
    },
    shippingTypes: state => {
      return state.shippingTypes
    },
    shippingTypesShared: state => {
      return state.shippingTypesShared
    },
    shippingSettings: state => {
      return state.shippingSettings
    },
    platforms: state => {
      return state.platforms
    },
    receiverTypes: state => {
      return state.receiverTypes
    },
    shippingStatusReasons: state => {
      return state.shippingStatusReasons
    },
    tobereturnedStatusReasons: state => {
      return state.tobereturnedStatusReasons
    },
    geoTypes: state => {
      return state.geoTypes
    },
    spinner: state => {
      return state.spinner
    },
    vehicleTypeGroupVehicleTypes: state => {
      return state.vehicleTypeGroupVehicleTypes
    },
    commodityVarieties: state => {
      return state.commodityVarieties
    }
  },
  mutations: {
    resetConfigCount: (state) => {
      state.toConfig = 0
      state.configured = 0
    },
    addToConfig: (state) => {
      state.toConfig++
    },
    addConfigured: (state) => {
      state.configured++
    },
    configComplete: (state, payload) => {
      setTimeout(() => {
        console.log(state.configured, payload)

        state.configComplete = payload
      }, 1000)
    },
    setPossibleProducts: (state, payload) => {
      if (payload.length) {
        state.possibleProducts = payload
        state.configured++
      }
    },
    checkEcosystem: (state, payload) => {
      console.log(ConfigService.getEcosystems())
    },
    setEcosystem: (state, payload) => {
      if (payload) {
        document.documentElement.className = payload.theme
        state.ecosystem = {...payload, product: window.product}
        state.configured++
      }
    },
    setEcosystemCountries: (state, payload) => {
      console.log(state.eid)
      console.log(payload)
      return ConfigService.getCountries(payload)
        .then(response => {
          state.ecosystemCountries = response.body.data
          window.countries = response.body.data
          state.configured++
        }, () => state.toConfig--)
    },
    setFrontConfig: (state, payload) => {
      if (payload) {
        state.frontConfig = payload
        state.configured++
      }
    },
    setEcosystemModules: async (state, payload) => {
      return await ConfigService.getEcosystem(payload)
        .then(response => {
          const frontConfig = response.body.front_config || {}

          // Modules
          const baseModules = state.ecosystemModules
          const productModules = frontConfig[window.product]?.modules
          const remoteModules = frontConfig.modules
          state.ecosystemModules = applyProductOverride({...baseModules, ...remoteModules, remote: true}, productModules)

          // General Config
          const baseConfig = { ...state.ecosystemConfig, remote: true }
          const productGeneralConfig = frontConfig[window.product]?.general
          const generalConfig = frontConfig.general

          state.ecosystemConfig = applyProductOverride({...baseConfig, ...generalConfig}, productGeneralConfig)
          // Plugins
          const basePlugins = { remote: true }
          const productPlugins = frontConfig[window.product]?.plugins
          const remotePlugins = frontConfig.plugins
          state.ecosystemPlugins = applyProductOverride({...basePlugins, ...remotePlugins}, productPlugins)

          // Maps
          if (frontConfig.maps) {
            const processedProviders = frontConfig.maps.providers.map(processMapProvider)
            state.ecosystemMaps = { ...frontConfig.maps, providers: processedProviders, remote: true }
          }

          // Ecosystem
          if (frontConfig.ecosystem) {
            const baseEcosystem = {...state.ecosystem}
            const productEcosystem = frontConfig[window.product]?.ecosystem
            const remoteEcosystem = frontConfig.ecosystem
            state.ecosystem = applyProductOverride({...baseEcosystem, ...remoteEcosystem}, productEcosystem)

            if (state.ecosystem.logo) {
              state.logo = state.ecosystem.logo
            }
            if (state.ecosystem.logoPinned) {
              state.logoPinned = state.ecosystem.logoPinned
            }
          }

          state.configured++
        }, () => state.toConfig--)
    },
    setModels: (state, payload) => {
      console.log(state.ecosystem?.product)

      const product = state.ecosystem?.product.charAt(0).toUpperCase() + state.ecosystem?.product.substr(1).toLowerCase()

      if (payload) {
        const productModelKeys = Object.keys(payload).filter(x => x.toLocaleLowerCase().includes(product.toLocaleLowerCase()))
        let productModels = productModelKeys.reduce((obj, key) => ({ ...obj, [key]: payload[key] }), {})
        productModels = renameKeys(productModels, function (key, val) {
          return key.replace(`Model${product}`, '')
        })

        let models = renameKeys(payload, function (key, val) {
          return key.replace('Model', '')
        })

        state.models = {...models, ...productModels}
        state.configured++
      }
    },
    setDataTransformers: (state, payload) => {
      if (payload) {
        state.dataTransformers = payload
        state.configured++
      }
    },
    setQuickFilters: (state, payload) => {
      console.log('quickFiltersSetup', JSON.parse(JSON.stringify(payload)))
      const product = state.ecosystem?.product.charAt(0).toUpperCase() + state.ecosystem?.product.substr(1).toLowerCase()
      if (payload) {
        const productModelKeys = Object.keys(payload).filter(x => x.toLocaleLowerCase().includes(product.toLocaleLowerCase()))
        let productModels = productModelKeys.reduce((obj, key) => ({ ...obj, [key]: payload[key] }), {})
        productModels = renameKeys(productModels, function (key, val) {
          return key.replace(`QuickFilters${product}`, '')
        })
        // state.quickFiltersSetup = payload
        const quickFiltersSetup = renameKeys(payload, function (key, val) {
          return key.replace('QuickFilters', '')
        })
        state.quickFiltersSetup = {...quickFiltersSetup, ...productModels}
        for (const key in state.quickFiltersSetup) {
          if (Object.prototype.hasOwnProperty.call(state.quickFiltersSetup, key)) {
            const element = state.quickFiltersSetup[key]
            state.plainQuickFiltersSetup[key] = setFilters(element.filters)
          }
        }
        console.log(state.plainQuickFiltersSetup)
        state.configured++
      }
    },
    setMapFilters: (state, payload) => {
      if (payload) {
        state.mapFiltersSetup = payload
        state.configured++
      }
    },
    setAppRoles: async (state, payload) => {
      return await ConfigService.getRoles(payload)
        .then(response => {
          if (window.product !== 'full') {
            const appRoles = response.body.data.map((item) => {
              if (window.allowedRoles[window.product].map(x => x.role).indexOf(item.name) !== -1) {
                return {
                  value: item.id,
                  text: item.name
                }
              }
            }).filter(Boolean)

            setTimeout(() => {
              state.appRoles = appRoles.map(x => {
                if (state.ecosystem.product !== 'carriers' && state.ecosystemModules.remote && !state.ecosystemModules.carriers && x.text === 'gcm-admin') {
                  return null
                } else {
                  return x
                }
              }).filter(Boolean)
              window.allowedRoles[window.product] = window.allowedRoles[window.product].filter(x => state.appRoles.map(y => y.text).indexOf(x.role) !== -1)
              state.configured++
            }, 1000)
          } else {
            let roles = response.body.data.map(x => {
              return {
                value: x.id,
                text: x.name
              }
            })
            if (!state.isMoova) {
              roles.splice(roles.findIndex(x => x.text === 'super-admin'), 1)
            }
            state.appRoles = roles.filter(role => {
              if (role.text === window.roles.SUPER_ADMIN) {
                return !!(state.isSuperAdmin)
              }
              if (role.text === window.roles.ADMIN) {
                return !!(state.isSuperAdmin || state.isAdmin)
              }
              return state.isSuperAdmin ||
                state.isAdmin ||
                ((state.isOperatorSupervisor || state.isOnboarding) && (role.text === window.roles.OPERATOR || role.text === window.roles.WAREHOUSE_OPS)) ||
                role.text !== window.roles.ADMIN &&
                role.text !== window.roles.OPERATOR_SUPERVISOR &&
                role.text !== window.roles.ACCOUNTANT &&
                role.text !== window.roles.ACCOUNT_APPROVER &&
                role.text !== window.roles.INTERNATIONAL &&
                role.text !== window.roles.COMMERCIAL &&
                role.text !== window.roles.OPERATOR &&
                role.text !== window.roles.WAREHOUSE_OPS &&
                role.text !== window.roles.INTEGRATOR &&
                role.text !== window.roles.HEAD_OPERATIONS &&
                role.text !== window.roles.HEAD_SALES &&
                role.text !== window.roles.ONBOARDING &&
                role.text !== window.roles.COURIER_ADMIN
            })
            const rolesDisabledByRole = state.appRoles.map(role => {
              if (state.isSuperAdmin || state.isAdmin || state.isOnboarding || (state.isCourierAdmin && role.text === window.roles.COURIER)) {
                return role
              } else {
                return {...role, disabled: true}
              }
            })

            // state.appRoles = response.body.data.map(x => {
            //   return {
            //     value: x.id,
            //     text: x.name
            //   }
            // })
            roles = state.appRoles.map(x => {
              return {
                id: x.value,
                product: 'default',
                role: x.text
              }
            })
            window.allowedRoles[window.product] = [...roles]
            window.rolesDisabledByRole = rolesDisabledByRole
            state.configured++
          }
        }, () => state.toConfig--)
    },
    setVehicleTypes: (state, payload) => {
      return ConfigService.getVehicleTypes(payload)
        .then(response => {
          state.vehicleTypes = response.body.data
          state.configured++
        }, () => state.toConfig--)
    },
    setShippingSizes: (state, payload) => {
      return ConfigService.getShippingSizes(payload)
        .then(response => {
          state.shippingSizes = response.body.data
          state.configured++
        }, () => state.toConfig--)
    },
    setShippingTypes: (state, payload) => {
      return ConfigService.getShippingTypes(payload)
        .then(response => {
          if (window.product !== 'full') {
            state.shippingTypesShared = response.body.data.map((item) => {
              return {
                value: item.id,
                text: item.name
              }
            })
            state.shippingTypes = response.body.data.map((item) => {
              if (window.allowedShippingTypes.indexOf(item.name) !== -1) {
                return {
                  value: item.id,
                  text: item.name
                }
              }
            }).filter(Boolean)
          } else {
            state.shippingTypes = response.body.data.map((item) => {
              return {
                value: item.id,
                text: item.name
              }
            })
          }
          state.configured++
        }, () => state.toConfig--)
    },
    setShippingSettings: (state, payload) => {
      return ConfigService.getShippingSettings(payload)
        .then(response => {
          state.shippingSettings = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          }).filter(Boolean)
          state.configured++
        }, () => state.toConfig--)
    },
    setPlatforms: (state, payload) => {
      return ConfigService.getPlatforms(payload)
        .then(response => {
          state.platforms = response.body.data
          state.configured++
        }, () => state.toConfig--)
    },
    setReceiverTypes: (state, payload) => {
      return ConfigService.getReceiverTypes(payload)
        .then(response => {
          state.receiverTypes = response.body.data
          state.configured++
        }, () => state.toConfig--)
    },
    setShippingStatusReasons: (state, payload) => {
      return ConfigService.getShippingStatusReasons(payload)
        .then(response => {
          state.shippingStatusReasons = response.body.data
          for (let i = 0; i < response.body.data.length; i++) {
            if (!state.shippingStatusReasons[response.body.data[i].event]) {
              state.shippingStatusReasons[response.body.data[i].event] = []
            }
            // reset the shipping_status_reasons events to match shipping statuses
            if (response.body.data[i].event === 'PICKEDUP') {
              response.body.data[i].event = 'CONFIRMED'
            } else if (response.body.data[i].event === 'DELIVERED') {
              state.tobereturnedStatusReasons.push({name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id})
              response.body.data[i].event = 'INTRANSIT'
            }
            state.shippingStatusReasons[response.body.data[i].event].push({name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id})
          }
          state.configured++
        }, () => state.toConfig--)
    },
    setGeoTypes: (state, payload) => {
      return ConfigService.getGeoTypes(payload)
        .then(response => {
          state.geoTypes = response.body.data
          state.configured++
        }, () => state.toConfig--)
    },
    showSpinner: (state) => {
      state.spinner = true
    },
    hideSpinner: (state) => {
      state.spinner = false
    },
    setVehicleTypeGroupVehicleTypes: (state, payload) => {
      state.vehicleTypeGroupVehicleTypes = payload
    },
    setCommodityVarieties: (state, payload) => {
      state.commodityVarieties = payload
    }
  },
  actions: {
    checkEcosystem: ({ commit }, payload) => {
      commit('checkEcosystem', payload)
    },
    setEcosystem: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setEcosystem', payload)
    },
    setEcosystemCountries: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setEcosystemCountries', payload)
    },
    setFrontConfig: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setFrontConfig', payload)
    },
    setEcosystemModules: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setEcosystemModules', payload)
    },
    setModels: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setModels', payload)
    },
    setDataTransformers: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setDataTransformers', payload)
    },
    setQuickFilters: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setQuickFilters', payload)
    },
    setMapFilters: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setMapFilters', payload)
    },
    setAppRoles: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setAppRoles', payload)
    },
    setVehicleTypes: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setVehicleTypes', payload)
    },
    setShippingSizes: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setShippingSizes', payload)
    },
    setShippingTypes: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setShippingTypes', payload)
    },
    setShippingSettings: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setShippingSettings', payload)
    },
    setPlatforms: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setPlatforms', payload)
    },
    setReceiverTypes: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setReceiverTypes', payload)
    },
    setShippingStatusReasons: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setShippingStatusReasons', payload)
    },
    setGeoTypes: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setGeoTypes', payload)
    },
    showSpinner: ({ commit }) => {
      commit('showSpinner')
    },
    hideSpinner: ({ commit }) => {
      commit('hideSpinner')
    },
    setVehicleTypeGroupVehicleTypes: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setVehicleTypeGroupVehicleTypes', payload)
    },
    setCommodityVarieties: ({ commit }, payload) => {
      commit('addToConfig')
      commit('setCommodityVarieties', payload)
    }
  }
}
